import { useEffect, useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { useForm } from 'react-hook-form'
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from 'react-query'
import { ValidationSchema } from "../services/schemaValidation";
import { ValidateErrorMessage } from "components/ValidateErrorMessage";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { edit } from "../services/api";
import FormBuilder from "components/Inputs/FormBuilder";
import { DataFields } from "../Add/DataFields";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import ImageManager from "components/ImageManager";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("America/Mexico_City");

export default function Edit({ open, close, menu, instance, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [dataInstance, setDataInstance] = useState({})
  const [imageManagerModalOpen, setImageManagerModalOpen] = useState(false)
  const [dataFieldImageManager, setDataFieldImageManager] = useState(null)
  const [validateDiffDates, setValidateDiffDates] = useState(false)
  let { reset, handleSubmit, register, formState: { errors }, setValue, getValues } = useForm({
    resolver: yupResolver(ValidationSchema)
  })
  const [urlTemp, setUrlTemp] = useState(null)

  useEffect(() => {
    if (open) {
      const url = instance.url
      setUrlTemp(url)
      //delete instance.url
      setDataInstance(instance)
      reset(instance)
      checkDateTime(instance.validity_start_datetime, instance.validity_end_datetime)
    } // eslint-disable-next-line
  }, [open])

  const mutation = useMutation(edit, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        reportAction(false, 'Error al guardar los datos', 'error')
      } else { reportAction(true, 'Acción realizada correctamente', 'success') }
    }
  })

  const handleEdit = (params) => {
    let id = params._id
    delete params._id
    delete params.deleted
    delete params.createdAt
    delete params.updatedAt
    params.validity_start_datetime = dayjs(params.validity_start_datetime).format("L LT")
    params.validity_end_datetime = dayjs(params.validity_end_datetime).format("L LT")

    const formData = new FormData()
    console.log("urlTemp", urlTemp)
    for (const key in params) {
      if (key === 'url') {
        if (Array.isArray(params.url)) {
          formData.append("url", params.url[0].file)
        } else {
          formData.append("url", urlTemp)
        }
      } else {
        if (key === "header") {
          for (const keyHeader in params.header) {
            formData.append(`header[${keyHeader}]`, params.header[keyHeader])
          }
        } else {
          formData.append(key, params[key])
        }

      }
    }
    if(formData.get("url") === null) formData.append("url", urlTemp)

    formData.append("menu", menu)
    for (const value of formData.values()) { console.log(value); }
    setIsLoading(true)
    mutation.mutate({ id: id, params: formData })
  }

  const handleClose = () => { reset(); setDataInstance({}); close() }

  const handleOnChangeData = (event) => {
    if (event.target.name.includes(".")) {
      const separate = event.target.name.split(".")
      setDataInstance({ ...dataInstance, [separate[0]]: { ...dataInstance[separate[0]], [separate[1]]: event.target.value } })
      return;
    }
    setDataInstance({ ...dataInstance, [event.target.name]: event.target.value })
  }

  const handleChangeBoolean = (name) => {
    setDataInstance({ ...dataInstance, [name]: !dataInstance[name] })
  }

  const handleChangeDateTimePicker = (name, value) => {
    setDataInstance({ ...dataInstance, [name]: value })
    setValue(name, value)
    checkDateTime(getValues("validity_start_datetime"), getValues("validity_end_datetime"))
  }

  // check if datetime2 is greater than datetime1
  const checkDateTime = (datetime1, datetime2) => {
    if (datetime1 === "" || datetime2 === "") return true;
    const date1 = new Date(datetime1)
    const date2 = new Date(datetime2)
    setValidateDiffDates(date1 < date2)
    return true
  }

  /*Handlers Image manager */
  const handleOpenImageManager = () => { setImageManagerModalOpen(true) }
  const handleCloseImageManager = (prop) => { setImageManagerModalOpen(prop) }
  const handleFieldImageManager = (prop) => { setDataFieldImageManager(prop) }
  const handleSelectImageManager = (url) => {
    setDataInstance({ ...dataInstance, [dataFieldImageManager]: url })
    setValue(dataFieldImageManager, url)
  }

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t("button_text_cancel")}</Button>
      <Button variant="contained" color="info" onClick={handleSubmit(handleEdit)} disabled={instance === dataInstance || !validateDiffDates}>{t("button_text_edit")}</Button>
    </> : <CircularProgress />}
  </>)

  return (<>
    {open ? <>
      <FlexibleWidthDialog open={open} title={t("promotions_dialog_title_edit")} actions={<Actions />}>
        <>
          {/* <input type="hidden" name="menu" {...register(`menu`)} value={menu}/> */}
          <ValidateErrorMessage message={errors.menu?.message} />
          <FormBuilder
            dataDields={DataFields(t)}
            dataInstance={dataInstance}
            register={register}
            errors={errors}
            changeDataFunction={handleOnChangeData}
            changeDataBoolean={handleChangeBoolean}
            changeDateTimePicker={handleChangeDateTimePicker}
            openImageManager={handleOpenImageManager}
            setFieldImageManager={handleFieldImageManager} />
          {!validateDiffDates ?
            <ValidateErrorMessage message="La fecha y hora de termino de la vigencia no puede ser igual o menor a la fecha y hora de inicio" />
            : null}
        </>
      </FlexibleWidthDialog>
      <ImageManager
        open={imageManagerModalOpen}
        actionClose={handleCloseImageManager}
        multipleImages={false}
        setImages={handleSelectImageManager} />
    </> : null}
  </>)
}